import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./LumaMenu.module.scss";
import lumaLogo from "../../assets/images/luma_logo_transparent.png";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

const MAX_VISIBLE_ITEMS = 7;
const CAPACITY_COLUMNS = ["4cL", "50cL", "70cL", "1L"];

const MENU_SECTIONS_FR = [
  {
    id: "entrees",
    tabLabel: "Entrées",
    drawerLabel: "Entrées froides",
    title: "ENTRÉES FROIDES",
    items: [
      { name: "Salade César", price: "32dt" },
      { name: "Salade tropicale", price: "38dt" },
      { name: "Salade burrata", price: "38dt" },
      { name: "Salade de poulpe", price: "48dt" },
      { name: "Carpaccio de boeuf", price: "48dt" },
      { name: "Salade camembert", price: "48dt" },
      { name: "Carpaccio de poulpe", price: "58dt" },
    ],
  },
  {
    id: "tapas",
    tabLabel: "Tapas",
    drawerLabel: "Tapas",
    title: "TAPAS",
    items: [
      { name: "Chicken tenders", price: "40dt" },
      { name: "Camembert pané", price: "45dt" },
      { name: "Calamars dorés", price: "48dt" },
      { name: "Gratin aux fruits de mer", price: "48dt" },
      { name: "Crevettes tempura", price: "48dt" },
      { name: "Crevettes à l'ail à l'espagnole", price: "48dt" },
      { name: "Chevrette panée", price: "48dt" },
      { name: "Mini burgers (6p)", price: "50dt" },
      { name: "Mini tacos (4p)", price: "50dt" },
      { name: "Crevettes à la crème", price: "52dt" },
      {
        name: "Fritto misto (Calamars dorés, crevettes panées, seiches panées)",
        price: "52dt",
      },
      { name: "Assortiment de charcuterie et fromage", price: "65dt" },
      { name: "Brochettes de veau gratinées, sauce grecque", price: "68dt" },
      { name: "Poulpe grillé à la méditerranéenne", price: "88dt" },
    ],
  },
  {
    id: "pates",
    tabLabel: "Pâtes",
    drawerLabel: "Pâtes",
    title: "PÂTES",
    items: [
      { name: "Tagliatelle au poulet, sauce champignons", price: "48dt" },
      { name: "Farfalle au saumon", price: "48dt" },
      { name: "Rigatoni aux crevettes, sauce rosée", price: "48dt" },
      { name: "Ravioli 4 fromages", price: "48dt" },
      { name: "Ravioli au saumon", price: "50dt" },
      { name: "Spaghetti tunisienne aux fruits de mer", price: "62dt" },
      { name: "Linguine alle vongole à l'italienne", price: "62dt" },
    ],
  },
  {
    id: "plats",
    tabLabel: "Plats",
    drawerLabel: "Plats",
    title: "PLATS",
    items: [
      { name: "Suprême de poulet, sauce champignons", price: "52dt" },
      { name: "Escalope de poulet parmigiana", price: "52dt" },
      { name: "Pavé de saumon à la crème", price: "68dt" },
      { name: "Risotto fruits de mer", price: "72dt" },
      { name: "Risotto au filet de boeuf", price: "72dt" },
      { name: "Oeufs de seiches", price: "72dt" },
      { name: "Crevettes royales grillées", price: "78dt" },
      { name: "Fruits de mer sautés", price: "78dt" },
      { name: "Entrecôte de boeuf", price: "82dt" },
      { name: "Mérou grillé", price: "88dt" },
      {
        name: "Filet de veau sauce au choix ou émincé (Champignons, Poivre, Truffes)",
        price: "92dt",
      },
      {
        name: "Smoked filet (Filet de veau, gratiné au fromage & bacon)",
        price: "98dt",
      },
      { name: "Poisson du jour (100g)", price: "18dt" },
    ],
  },
  {
    id: "desserts",
    tabLabel: "Desserts",
    drawerLabel: "Desserts",
    title: "DESSERTS",
    items: [
      { name: "Cheese cake", price: "22dt" },
      { name: "Fondant au chocolat", price: "22dt" },
      { name: "Sorbetti gelati (2 boules glaces au choix)", price: "32dt" },
      { name: "Tiramisu", price: "32dt" },
      { name: "Assiette de fruits de saison", price: "75dt" },
    ],
  },
  {
    id: "cocktails",
    tabLabel: "Cocktails",
    drawerLabel: "Cocktails",
    title: "COCKTAILS ALCOOLISÉS",
    items: [
      { name: "Espresso Martini", price: "30dt" },
      { name: "Lüma", price: "35dt" },
      { name: "Blue Hawaii", price: "30dt" },
      { name: "Mojito", price: "28dt" },
      { name: "Blue Lagoon", price: "28dt" },
      { name: "Margarita", price: "28dt" },
      { name: "Tequila Sunrise", price: "28dt" },
      { name: "Black Berry", price: "30dt" },
      { name: "Cool", price: "30dt" },
    ],
  },
  {
    id: "spirits",
    tabLabel: "Spirits",
    drawerLabel: "Spirits",
    title: "SPIRITS",
    sizeColumns: CAPACITY_COLUMNS,
    sizeRows: [
      { name: "Smirnoff", prices: { "4cL": "17dt", "50cL": "150dt", "1L": "300dt" } },
      { name: "Gin Gordon's", prices: { "4cL": "19dt", "1L": "300dt" } },
      { name: "Absolut", prices: { "4cL": "19dt", "50cL": "180dt", "1L": "360dt" } },
      { name: "Raspberry / Citron", prices: { "1L": "360dt" } },
      { name: "Absolut 100", prices: { "1L": "360dt" } },
      { name: "Grey Goose", prices: { "4cL": "25dt", "1L": "600dt" } },
      { name: "Belvédère", prices: { "4cL": "25dt", "50cL": "360dt", "1L": "600dt" } },
      {
        name: "Belvédère Arôme (Blackberry & Lemongrass / Lemon & Basil / Pear & Ginger)",
        prices: { "70cL": "500dt" },
      },
      { name: "Ciroc", prices: { "1L": "600dt" } },
      { name: "Roberto Cavalli", prices: { "1L": "600dt" } },
      { name: "Roberto Cavalli Night Edition", prices: { "1L": "650dt" } },
      { name: "Roberto Cavalli Gold", prices: { "1L": "650dt" } },
    ],
  },
  {
    id: "whiskys",
    tabLabel: "Whiskys",
    drawerLabel: "Whiskys",
    title: "WHISKYS",
    sizeColumns: CAPACITY_COLUMNS,
    sizeRows: [
      { name: "JB", prices: { "4cL": "20dt", "1L": "300dt" } },
      { name: "Red Label", prices: { "4cL": "20dt", "50cL": "220dt", "1L": "350dt" } },
      { name: "Jack Daniel's", prices: { "4cL": "26dt", "70cL": "450dt", "1L": "550dt" } },
      {
        name: "Black Label",
        prices: { "4cL": "30dt", "50cL": "350dt", "70cL": "450dt", "1L": "550dt" },
      },
      { name: "Double Black", prices: { "4cL": "34dt", "1L": "700dt" } },
      { name: "Chivas", prices: { "4cL": "34dt", "70cL": "450dt", "1L": "600dt" } },
      { name: "Jack Daniel's Honey", prices: { "70cL": "500dt", "1L": "600dt" } },
      { name: "Jack Daniel's Apple", prices: { "70cL": "500dt", "1L": "550dt" } },
      { name: "Jack Daniel's 1,75L", prices: { "1L": "850dt" } },
    ],
  },
  {
    id: "vins",
    tabLabel: "Vins",
    drawerLabel: "Vins",
    title: "VINS",
    wineGroups: [
      {
        title: "VIN ROUGE",
        rows: [
          { name: "Magon", size: "37,5cL / 50cL", price: "40dt / 65dt" },
          { name: "Signature", size: "50cL", price: "72dt" },
          { name: "Shadrappa", size: "50cL", price: "75dt" },
          { name: "Selian", size: "37,5cL / 50cL", price: "90dt / 75dt" },
          { name: "Magnifique Réserve", size: "50cL", price: "75dt" },
          { name: "Soltane", size: "50cL", price: "75dt" },
          { name: "Gioia", size: "50cL", price: "75dt" },
          { name: "Vieux Magon", size: "50cL / 75cL", price: "50dt / 80dt" },
          { name: "Didona", size: "75cL", price: "85dt" },
          { name: "Kurubis", size: "50cL / 75cL", price: "60dt / 85dt" },
          { name: "Bougène", size: "75cL", price: "90dt" },
          { name: "Vieux Magnifique", size: "75cL", price: "90dt" },
          { name: "Saint Emilion", size: "75cL", price: "130dt" },
        ],
      },
      {
        title: "VIN ROSÉ",
        rows: [
          { name: "Magon", size: "37,5cL / 50cL", price: "40dt / 65dt" },
          { name: "Pétale", size: "50cL", price: "65dt" },
          { name: "Désir", size: "50cL", price: "70dt" },
          { name: "Jour et Nuit", size: "37,5cL / 50cL", price: "40dt / 70dt" },
          { name: "Signature", size: "50cL", price: "72dt" },
          { name: "Gioia", size: "50cL", price: "75dt" },
          { name: "Soltane", size: "50cL", price: "75dt" },
          { name: "Magnifique", size: "50cL", price: "80dt" },
          { name: "Crazy", size: "75cL", price: "110dt" },
          { name: "Minuty", size: "75cL", price: "180dt" },
        ],
      },
      {
        title: "VIN BLANC",
        rows: [
          { name: "Jour et Nuit", size: "75cL", price: "70dt" },
          { name: "Soltane", size: "75cL", price: "75dt" },
          { name: "Chardonnay", size: "75cL", price: "75dt" },
          { name: "Kurubis", size: "75cL", price: "80dt" },
          { name: "Magnifique", size: "75cL", price: "85dt" },
          { name: "Chopin Ice", size: "75cL", price: "130dt" },
          { name: "Wine shot", size: "Verre", price: "40dt" },
        ],
      },
    ],
  },
  {
    id: "champagnes",
    tabLabel: "Champagnes",
    drawerLabel: "Champagnes",
    title: "CHAMPAGNES",
    items: [
      { name: "Martini Prosecco 75cL", price: "290dt" },
      { name: "Mumm Cordon Rouge", price: "700dt" },
      { name: "Moët Chandon", price: "700dt" },
      { name: "Veuve Cliquot", price: "700dt" },
    ],
  },
  {
    id: "bieres",
    tabLabel: "Bières",
    drawerLabel: "Bières",
    title: "BIÈRES",
    items: [
      { name: "Celtia", price: "10dt" },
      { name: "Beck's", price: "10dt" },
      { name: "Amstel", price: "10dt" },
      { name: "Heineken", price: "10dt" },
      { name: "Smirnoff Ice", price: "28dt" },
    ],
  },
  {
    id: "shooters",
    tabLabel: "Shooters",
    drawerLabel: "Shooters",
    title: "SHOOTERS",
    items: [
      { name: "B52", price: "18dt" },
      { name: "Absinthe", price: "18dt" },
      { name: "Tequila mexicaine", price: "14dt" },
      { name: "Tequila Camino", price: "18dt" },
      { name: "Jägermeister", price: "20dt" },
      { name: "B55", price: "20dt" },
    ],
  },
  {
    id: "soft",
    tabLabel: "Soft",
    drawerLabel: "Soft",
    title: "SOFT",
    items: [
      { name: "Eau minérale / gazéifiée", price: "8dt" },
      { name: "Café", price: "8dt" },
      { name: "Boissons gazeuses", price: "10dt" },
      { name: "Boissons énergétiques", price: "12dt" },
      { name: "Schweppes tonic 1L", price: "20dt" },
      { name: "Virgin Mojito", price: "22dt" },
      { name: "Black Berry", price: "22dt" },
    ],
  },
];

const UI_TEXT = {
  fr: {
    home: "Accueil",
    contact: "Contact",
    discover: "Découvrir la carte",
    seeMore: "Voir plus ↓",
    seeLess: "Voir moins ↑",
    tableName: "Nom",
    tableSize: "Contenance",
    tablePrice: "Prix",
    welcomeStrong: "Bienvenue chez Lüma.",
    welcomeLines: [
      "Chez Luma, chaque plat est une invitation au voyage.",
      "Notre cuisine Maison célèbre la générosité tunisienne à travers des produits de saison soigneusement sélectionnés.",
      "Des saveurs ensoleillées, des recettes authentiques revisitées avec élégance, et des desserts gourmands à savourer à tout moment.",
      "Une carte pensée pour toutes les envies.",
      "Les lumières baissent, la musique monte...",
      "Live bands, DJ sets, cocktails signatures — l’ambiance évolue, l’expérience s’intensifie.",
      "Des assiettes à partager, des saveurs qui marquent, une énergie qui vous emporte jusqu’au bout de la nuit.",
      "Lüma... là où la nuit commence vraiment.",
    ],
  },
  en: {
    home: "Home",
    contact: "Contact",
    discover: "Discover the menu",
    seeMore: "See more ↓",
    seeLess: "See less ↑",
    tableName: "Name",
    tableSize: "Size",
    tablePrice: "Price",
    welcomeStrong: "Welcome to Lüma.",
    welcomeLines: [
      "At Lüma, every dish is an invitation to travel.",
      "Our house cuisine celebrates Tunisian generosity through carefully selected seasonal products.",
      "Sun-kissed flavors, authentic recipes revisited with elegance, and gourmet desserts to enjoy at any moment.",
      "A menu designed for every taste.",
      "The lights dim, the music rises...",
      "Live bands, DJ sets, signature cocktails — the atmosphere evolves and the experience intensifies.",
      "Dishes to share, memorable flavors, an energy that carries you through the night.",
      "Lüma... where the night truly begins.",
    ],
  },
};

const SECTION_TRANSLATIONS_EN = {
  entrees: { tabLabel: "Starters", drawerLabel: "Cold starters", title: "COLD STARTERS" },
  tapas: { tabLabel: "Tapas", drawerLabel: "Tapas", title: "TAPAS" },
  pates: { tabLabel: "Pasta", drawerLabel: "Pasta", title: "PASTA" },
  plats: { tabLabel: "Main Dishes", drawerLabel: "Main dishes", title: "MAIN DISHES" },
  desserts: { tabLabel: "Desserts", drawerLabel: "Desserts", title: "DESSERTS" },
  cocktails: { tabLabel: "Cocktails", drawerLabel: "Cocktails", title: "ALCOHOLIC COCKTAILS" },
  spirits: { tabLabel: "Spirits", drawerLabel: "Spirits", title: "SPIRITS" },
  whiskys: { tabLabel: "Whiskies", drawerLabel: "Whiskies", title: "WHISKIES" },
  vins: { tabLabel: "Wines", drawerLabel: "Wines", title: "WINES" },
  champagnes: { tabLabel: "Champagnes", drawerLabel: "Champagnes", title: "CHAMPAGNES" },
  bieres: { tabLabel: "Beers", drawerLabel: "Beers", title: "BEERS" },
  shooters: { tabLabel: "Shooters", drawerLabel: "Shooters", title: "SHOOTERS" },
  soft: { tabLabel: "Soft", drawerLabel: "Soft", title: "SOFT" },
};

const GROUP_TRANSLATIONS_EN = {
  "VIN ROUGE": "RED WINE",
  "VIN ROSÉ": "ROSÉ WINE",
  "VIN BLANC": "WHITE WINE",
};

const ITEM_NAME_TRANSLATIONS_EN = {
  "Salade César": "Caesar Salad",
  "Salade tropicale": "Tropical Salad",
  "Salade de poulpe": "Octopus Salad",
  "Carpaccio de boeuf": "Beef Carpaccio",
  "Salade camembert": "Camembert Salad",
  "Carpaccio de poulpe": "Octopus Carpaccio",
  "Calamars dorés": "Golden Calamari",
  "Gratin aux fruits de mer": "Seafood Gratin",
  "Crevettes à l'ail à l'espagnole": "Spanish-Style Garlic Shrimp",
  "Chevrette panée": "Breaded Baby Shrimp",
  "Assortiment de charcuterie et fromage": "Charcuterie and Cheese Platter",
  "Brochettes de veau gratinées, sauce grecque": "Gratinated Veal Skewers, Greek Sauce",
  "Poulpe grillé à la méditerranéenne": "Mediterranean Grilled Octopus",
  "Tagliatelle au poulet, sauce champignons": "Chicken Tagliatelle, Mushroom Sauce",
  "Rigatoni aux crevettes, sauce rosée": "Shrimp Rigatoni, Rosé Sauce",
  "Ravioli 4 fromages": "Four Cheese Ravioli",
  "Spaghetti tunisienne aux fruits de mer": "Tunisian Seafood Spaghetti",
  "Linguine alle vongole à l'italienne": "Italian-Style Linguine alle Vongole",
  "Suprême de poulet, sauce champignons": "Chicken Supreme, Mushroom Sauce",
  "Escalope de poulet parmigiana": "Chicken Parmigiana Escalope",
  "Pavé de saumon à la crème": "Creamy Salmon Steak",
  "Risotto fruits de mer": "Seafood Risotto",
  "Risotto au filet de boeuf": "Beef Fillet Risotto",
  "Oeufs de seiches": "Cuttlefish Roe",
  "Crevettes royales grillées": "Grilled King Prawns",
  "Fruits de mer sautés": "Sautéed Seafood",
  "Entrecôte de boeuf": "Beef Entrecôte",
  "Mérou grillé": "Grilled Grouper",
  "Filet de veau sauce au choix ou émincé (Champignons, Poivre, Truffes)":
    "Veal Fillet with Sauce of Choice or Sliced (Mushroom, Pepper, Truffle)",
  "Poisson du jour (100g)": "Fish of the Day (100g)",
  "Fondant au chocolat": "Chocolate Fondant",
  "Assiette de fruits de saison": "Seasonal Fruit Plate",
  "Eau minérale / gazéifiée": "Still / Sparkling Water",
  Café: "Coffee",
  "Boissons gazeuses": "Soft Drinks",
  "Boissons énergétiques": "Energy Drinks",
};

function translateItemName(name) {
  return ITEM_NAME_TRANSLATIONS_EN[name] || name;
}

function buildEnglishSections(sections) {
  return sections.map((section) => {
    const sectionMeta = SECTION_TRANSLATIONS_EN[section.id] || {};
    const translatedSection = {
      ...section,
      tabLabel: sectionMeta.tabLabel || section.tabLabel,
      drawerLabel: sectionMeta.drawerLabel || section.drawerLabel,
      title: sectionMeta.title || section.title,
    };

    if (section.items) {
      translatedSection.items = section.items.map((item) => ({
        ...item,
        name: translateItemName(item.name),
      }));
    }

    if (section.sizeRows) {
      translatedSection.sizeRows = section.sizeRows.map((row) => ({
        ...row,
        name: translateItemName(row.name),
      }));
    }

    if (section.wineGroups) {
      translatedSection.wineGroups = section.wineGroups.map((group) => ({
        ...group,
        title: GROUP_TRANSLATIONS_EN[group.title] || group.title,
        rows: group.rows.map((row) => ({
          ...row,
          name: translateItemName(row.name),
          size: row.size === "Verre" ? "Glass" : row.size,
        })),
      }));
    }

    return translatedSection;
  });
}

const MENU_SECTIONS_EN = buildEnglishSections(MENU_SECTIONS_FR);

function LumaMenu() {
  const [language, setLanguage] = useState("fr");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("entrees");
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [pendingScrollTarget, setPendingScrollTarget] = useState(null);
  const [isStickyVisible, setIsStickyVisible] = useState(false);
  const [stickyHeight, setStickyHeight] = useState(0);

  const menuSections = useMemo(
    () => (language === "fr" ? MENU_SECTIONS_FR : MENU_SECTIONS_EN),
    [language]
  );
  const text = useMemo(() => UI_TEXT[language], [language]);
  const menuTabs = useMemo(
    () => [
      ...menuSections.map((section) => ({ id: section.id, label: section.tabLabel })),
      { id: "contact", label: text.contact },
    ],
    [menuSections, text.contact]
  );
  const drawerItems = useMemo(
    () => [
      { id: "accueil", label: text.home },
      ...menuSections.map((section) => ({ id: section.id, label: section.drawerLabel })),
      { id: "contact", label: text.contact },
    ],
    [menuSections, text.contact, text.home]
  );

  const sectionRefs = useRef({});
  const tabRefs = useRef({});
  const headerRef = useRef(null);
  const tabsRef = useRef(null);
  const stickyStackRef = useRef(null);
  const menuSectionRef = useRef(null);

  const setSectionRef = (id, node) => {
    if (node) {
      sectionRefs.current[id] = node;
    }
  };

  const getStickyOffset = useCallback(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const tabsHeight = tabsRef.current?.offsetHeight || 0;
    return headerHeight + tabsHeight + 12;
  }, []);

  const scrollToSection = useCallback((id) => {
    if (id === "accueil") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (id === "contact") {
      const contactNode = sectionRefs.current.contact || document.getElementById("contact");
      if (contactNode) {
        const targetY = contactNode.getBoundingClientRect().top + window.scrollY - getStickyOffset();
        window.scrollTo({ top: Math.max(targetY, 0), behavior: "smooth" });
        return;
      }
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
      return;
    }

    const target = sectionRefs.current[id] || document.getElementById(id);
    if (!target) return;

    const targetY = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
    window.scrollTo({ top: Math.max(targetY, 0), behavior: "smooth" });
  }, [getStickyOffset]);

  const navigateToSection = (id) => {
    if (drawerOpen) {
      setPendingScrollTarget(id);
      setDrawerOpen(false);
      return;
    }
    scrollToSection(id);
  };

  useEffect(() => {
    if (!pendingScrollTarget || drawerOpen) return undefined;

    const timeoutId = window.setTimeout(() => {
      scrollToSection(pendingScrollTarget);
      setPendingScrollTarget(null);
    }, 140);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [pendingScrollTarget, drawerOpen, scrollToSection]);

  const formatCapacityPrices = (row, sizeColumns) => {
    const labels = sizeColumns
      .filter((size) => row.prices?.[size])
      .map((size) => `${size}: ${row.prices[size]}`);

    return labels.join(" • ");
  };

  const toggleSection = (id) => {
    setExpandedSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const openItemModal = (item, sectionTitle) => {
    setSelectedItem({ ...item, sectionTitle });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 550);
      const menuTop = menuSectionRef.current?.offsetTop || 0;
      setIsStickyVisible(window.scrollY >= menuTop - 2);
      const nearBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 24;
      if (nearBottom) {
        setActiveCategory("contact");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const measureStickyHeight = () => {
      setStickyHeight(stickyStackRef.current?.offsetHeight || 0);
    };

    measureStickyHeight();
    window.addEventListener("resize", measureStickyHeight);
    return () => {
      window.removeEventListener("resize", measureStickyHeight);
    };
  }, []);

  useEffect(() => {
    const sectionsToObserve = menuTabs.map((tab) => sectionRefs.current[tab.id]).filter(Boolean);
    if (!sectionsToObserve.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visibleEntry?.target?.id) {
          setActiveCategory(visibleEntry.target.id);
        }
      },
      {
        root: null,
        rootMargin: "-26% 0px -64% 0px",
        threshold: [0.15, 0.35, 0.55],
      }
    );

    sectionsToObserve.forEach((section) => observer.observe(section));

    return () => {
      observer.disconnect();
    };
  }, [menuTabs]);

  useEffect(() => {
    const onEscape = (event) => {
      if (event.key !== "Escape") return;
      if (selectedItem) setSelectedItem(null);
      if (drawerOpen) setDrawerOpen(false);
    };

    window.addEventListener("keydown", onEscape);
    return () => {
      window.removeEventListener("keydown", onEscape);
    };
  }, [drawerOpen, selectedItem]);

  useEffect(() => {
    if (!drawerOpen && !selectedItem) return undefined;

    const htmlStyle = document.documentElement.style;
    const bodyStyle = document.body.style;
    const originalHtmlOverflow = htmlStyle.overflow;
    const originalOverflow = bodyStyle.overflow;

    htmlStyle.overflow = "hidden";
    bodyStyle.overflow = "hidden";

    return () => {
      htmlStyle.overflow = originalHtmlOverflow;
      bodyStyle.overflow = originalOverflow;
    };
  }, [drawerOpen, selectedItem]);

  useEffect(() => {
    return () => {
      // Fail-safe unlock in case user leaves while a modal/drawer is open.
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    };
  }, []);

  return (
    <main className={styles.page}>
      <section id="accueil" ref={(node) => setSectionRef("accueil", node)} className={styles.landingSection}>
        <div className={styles.landingInner}>
          <img src={lumaLogo} alt="LÜMA Lounge" className={styles.logo} />
          <p className={styles.welcomeLineStrong}>{text.welcomeStrong}</p>
          {text.welcomeLines.map((line) => (
            <p key={line} className={styles.welcomeLine}>
              {line}
            </p>
          ))}
          <button className={styles.discoverButton} onClick={() => navigateToSection("entrees")}>
            {text.discover}
          </button>
        </div>
      </section>

      <section className={styles.menuSectionWrap} ref={menuSectionRef}>
        <div
          ref={stickyStackRef}
          className={`${styles.stickyStack} ${isStickyVisible ? styles.stickyVisible : styles.stickyHidden}`}
        >
          <header className={styles.stickyHeader} ref={headerRef}>
            <button className={styles.headerLogoBtn} onClick={() => navigateToSection("accueil")}>
              <img src={lumaLogo} alt="LÜMA" className={styles.headerLogo} />
            </button>
            <div className={styles.languageSwitch} role="group" aria-label="Menu language">
              <button
                className={`${styles.langButton} ${language === "fr" ? styles.langActive : ""}`}
                onClick={() => setLanguage("fr")}
              >
                FR
              </button>
              <button
                className={`${styles.langButton} ${language === "en" ? styles.langActive : ""}`}
                onClick={() => setLanguage("en")}
              >
                EN
              </button>
            </div>
            <button
              className={styles.hamburger}
              aria-label="Ouvrir le menu"
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen(true)}
            >
              <span />
              <span />
              <span />
            </button>
          </header>

          <nav className={styles.categoryNav} ref={tabsRef} aria-label="Catégories du menu">
            <div className={styles.categoryScroll}>
              {menuTabs.map((tab) => (
                <button
                  key={tab.id}
                  ref={(node) => {
                    if (node) tabRefs.current[tab.id] = node;
                  }}
                  className={`${styles.categoryTab} ${activeCategory === tab.id ? styles.activeTab : ""}`}
                  onClick={() => navigateToSection(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </nav>
        </div>
        <div className={styles.stickySpacer} style={{ height: isStickyVisible ? stickyHeight : 0 }} />

        <div className={styles.menuContainer}>
          {menuSections.map((section) => {
            const isWineSection = Boolean(section.wineGroups);
            const isCapacitySection = Boolean(section.sizeColumns && section.sizeRows);
            const items = section.items || [];
            const canToggle = !isWineSection && !isCapacitySection && items.length > MAX_VISIBLE_ITEMS;
            const isExpanded = Boolean(expandedSections[section.id]);
            const visibleItems = canToggle && !isExpanded ? items.slice(0, MAX_VISIBLE_ITEMS) : items;

            return (
              <section
                key={section.id}
                id={section.id}
                ref={(node) => setSectionRef(section.id, node)}
                className={styles.menuBlock}
              >
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.sectionLine} />

                {!isWineSection && (
                  <div className={styles.itemsList}>
                    {visibleItems.map((item) => (
                      <button
                        key={`${section.id}-${item.name}`}
                        className={styles.menuItem}
                        onClick={() => openItemModal(item, section.title)}
                      >
                        <span className={styles.itemName}>{item.name}</span>
                        <span className={styles.itemPrice}>{item.price}</span>
                      </button>
                    ))}
                  </div>
                )}

                {isCapacitySection && (
                  <div className={styles.capacityTableWrap}>
                    <div className={styles.capacityHeader}>
                      <span>{text.tableName}</span>
                      {section.sizeColumns.map((size) => (
                        <span key={`${section.id}-size-${size}`}>{size}</span>
                      ))}
                    </div>
                    {section.sizeRows.map((row) => (
                      <button
                        key={`${section.id}-${row.name}`}
                        className={styles.capacityRow}
                        onClick={() =>
                          openItemModal(
                            {
                              name: row.name,
                              price: formatCapacityPrices(row, section.sizeColumns),
                            },
                            section.title
                          )
                        }
                      >
                        <span className={styles.capacityName}>{row.name}</span>
                        {section.sizeColumns.map((size) => (
                          <span key={`${row.name}-${size}`} className={styles.capacityPrice}>
                            {row.prices?.[size] || "—"}
                          </span>
                        ))}
                      </button>
                    ))}
                  </div>
                )}

                {isWineSection && (
                  <div className={styles.wineGroups}>
                    {section.wineGroups.map((wineGroup) => (
                      <div key={wineGroup.title} className={styles.wineGroup}>
                        <h3 className={styles.wineTitle}>{wineGroup.title}</h3>
                        <div className={styles.wineTableHeader}>
                          <span>{text.tableName}</span>
                          <span>{text.tableSize}</span>
                          <span>{text.tablePrice}</span>
                        </div>
                        {wineGroup.rows.map((row) => (
                          <button
                            key={`${wineGroup.title}-${row.name}`}
                            className={styles.wineRow}
                            onClick={() =>
                              openItemModal(
                                {
                                  name: row.name,
                                  price: `${row.size} • ${row.price}`,
                                },
                                `${section.title} · ${wineGroup.title}`
                              )
                            }
                          >
                            <span>{row.name}</span>
                            <span>{row.size}</span>
                            <span>{row.price}</span>
                          </button>
                        ))}
                      </div>
                    ))}
                  </div>
                )}

                {canToggle && (
                  <button className={styles.expandButton} onClick={() => toggleSection(section.id)}>
                    {isExpanded ? text.seeLess : text.seeMore}
                  </button>
                )}
              </section>
            );
          })}

          <footer id="contact" ref={(node) => setSectionRef("contact", node)} className={styles.footer}>
            <div className={styles.footerLine} />
            <img src={lumaLogo} alt="LÜMA Lounge" className={styles.footerLogo} />
            <p>
              <a href="https://www.palaisroyal.com.tn" target="_blank" rel="noreferrer">
                www.palaisroyal.com.tn
              </a>
            </p>
            <div className={styles.socialLinks}>
              <a
                href="https://www.facebook.com/p/H%C3%B4tel-Palais-Royal-100062925625062/"
                target="_blank"
                rel="noreferrer"
                className={styles.socialLink}
                aria-label="Facebook Hôtel Palais Royal"
              >
                <FaFacebookF />
                <span>Hôtel Palais Royal</span>
              </a>
              <a
                href="https://www.instagram.com/hotelpalaisroyalsfax/"
                target="_blank"
                rel="noreferrer"
                className={styles.socialLink}
                aria-label="Instagram hotelpalaisroyalsfax"
              >
                <FaInstagram />
                <span>hotelpalaisroyalsfax</span>
              </a>
            </div>
            <p>Route Mahdia (Avenue Habib Bouguatfa), Sfax 3000, Tunisie</p>
            <p>
              <a href="tel:+21670146146">+216 70 146 146</a>
            </p>
            <div className={styles.footerBar} />
          </footer>
        </div>
      </section>

      {drawerOpen && (
        <div className={styles.drawerOverlay} onClick={() => setDrawerOpen(false)}>
          <aside className={styles.drawer} onClick={(event) => event.stopPropagation()}>
            <button className={styles.drawerClose} onClick={() => setDrawerOpen(false)} aria-label="Fermer le menu">
              ×
            </button>
            <nav className={styles.drawerNav}>
              {drawerItems.map((item) => (
                <button
                  key={item.id}
                  className={styles.drawerItem}
                  onClick={() => {
                    navigateToSection(item.id);
                  }}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </aside>
        </div>
      )}

      {selectedItem && (
        <div className={styles.modalOverlay} onClick={() => setSelectedItem(null)}>
          <div className={styles.modalSheet} onClick={(event) => event.stopPropagation()}>
            <button className={styles.modalClose} onClick={() => setSelectedItem(null)} aria-label="Fermer">
              ×
            </button>
            <p className={styles.modalSection}>{selectedItem.sectionTitle}</p>
            <h3 className={styles.modalName}>{selectedItem.name}</h3>
            <p className={styles.modalPrice}>{selectedItem.price}</p>
          </div>
        </div>
      )}

      {showBackToTop && (
        <button className={styles.backToTop} aria-label="Retour en haut" onClick={() => navigateToSection("accueil")}>
          ↑
        </button>
      )}
    </main>
  );
}

export default LumaMenu;
